import { render, staticRenderFns } from "./Customer-Setting.vue?vue&type=template&id=45cd6e47&scoped=true"
import script from "./Customer-Setting.vue?vue&type=script&lang=js"
export * from "./Customer-Setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cd6e47",
  null
  
)

export default component.exports